import React from 'react';

import { IButtonFields } from '@/types/contentful';

import { ButtonColorTokenProp } from '../../../theme/tokens/button-color';
import { CFColorTokenProp } from '../../../theme/tokens/contentful-color';

import { SubmitButton } from './styles';

interface FormSubmitProps
  extends Partial<Omit<IButtonFields, 'buttonColor' | 'buttonHoverColor'>> {
  handleOnSubmit: () => void;
  buttonColor?: ButtonColorTokenProp | CFColorTokenProp;
  buttonHoverColor?: ButtonColorTokenProp | CFColorTokenProp;
}

export function FormSubmit({
  text,
  buttonColor = 'ginger',
  buttonHoverColor = 'green',
  handleOnSubmit
}: FormSubmitProps) {
  return (
    <SubmitButton
      cfButtonColor={buttonColor as CFColorTokenProp}
      cfButtonHoverColor={buttonHoverColor as CFColorTokenProp}
      onClick={handleOnSubmit}
      data-testid="split-module-form-submit"
    >
      {text || 'Submit'}
    </SubmitButton>
  );
}
